const en = {
  app: {
    label: {
      true: 'Yes',
      false: 'No',
    },
    loginWidget: {
      email: 'E-Mail',
      forgotPassword: 'Forgot password?',
      login: 'Login',
      loginWelcome:
        'Welcome back. Please log in with your registered credentials.',
      next: 'Next',
      password: 'Password',
      title: 'Login',
    },
    resetWidget: {
      title: 'Forgot Password?',
      instructions:
        'Please enter your email address. If an account associated with this address exists, you will receive instructions to reset your password.',
      emailLabel: 'Email Address',
      emailPlaceholder: 'Enter your Email Address',
      back: 'Back to Login',
      submit: 'Submit',
      submitSso: 'Go to single sign-on portal',
    },
    resetConfirmationWidget: {
      title: 'New password requested',
      confirmation: 'Please check your email inbox for further instruction.',
      back: 'Back to Login',
    },
    changePasswordWidget: {
      title: 'Set password',
      forcedTitle: 'Reset password',
      instructions:
        'Please set your new password minding our password security recommendations.',
      placeholder: 'Password',
      newPasswordLabel: 'Set new password',
      confirmationLabel: 'Repeat new password',
      confirmationError: 'Passwords do not match each other',
      backToLogin: 'Go to Login',
      back: 'Back',
      submit: 'Set Password',
      recommendations: {
        characterCount: 'min. 10 characters',
        containing: 'containing',
      },
    },
    logout: 'Log out',
    inactivityLogout:
      'You were logged out due to inactivity. Please log in with your credentials again.',
    switchToLightTheme: 'Switch to light theme',
    switchToDarkTheme: 'Switch to dark theme',
    changePassword: 'Change password',
    settings: 'Settings',
    radioGroup: {
      current: 'Current',
    },
    userSettings: {
      title: 'User Settings',
      loginInformation: 'Login Information',
      loginDescription:
        'View your account information and change your password',
      portalSettings: 'Portal Settings',
      email: 'Email',
      language: 'Portal Language',
      colorMode: 'Color mode',
      lightMode: 'Light Mode',
      darkMode: 'Dark Mode',
      cancel: 'Cancel',
      saveAndExit: 'Save & Exit',
    },
    genericListWithLayoutModal: {
      title: 'Comparison settings',
      cancel: 'Cancel',
      apply: 'Compare',
      layoutLabel: 'Layout',
    },
    page: {
      loadingError: 'Failed to load application',
      genericError: 'An error occurred',
      pageNotFoundError: 'Page not found',
      unknownPageContentNodeError: 'Unknown page content node',
      retry: 'Try again',
      notLoadedTitle: 'Page could not be loaded',
      notLoadedErrorText:
        'The page you are looking for doesn’t exist or an error occurred. Please try again or contact your admin.',
      pageContentErrorTitle: 'Page content error',
      contentNotFoundError:
        'There was a problem loading the content. Please refresh the page or try again later.',
      backToDashboard: 'Back to Dashboard',
      close: 'Close Detail Page',
      editAction: {
        label: {
          customizePage: 'Customize page',
          archive: 'Archive',
          delete: 'Delete',
          share: 'Share',
          addComponent: 'Add Component',
          save: 'Save',
        },
        addComponentModal: {
          title: 'Add Component',
          cancel: 'Cancel',
          add: 'Add components',
          emptyCategories: 'No content library categories are configured.',
          noResults: 'No matching components found.',
          untitled: 'Untitled',
          loadError: 'Could not load content library data. Please try again.',
          searchError: 'Could not load components. Please try again.',
          selectComponentsInstruction:
            'Select one or more components to add to your dashboard',
          tables: 'Tables',
          charts: 'Charts',
        },
      },
    },
    pageFilter: {
      placeholder: 'All',
      reset: 'Reset filters',
      autoSaveEnabled: 'Filter selections are automatically persisted',
      autoSaveDisabled: 'Filter selections are not automatically persisted',
      autoSaveForceEnabled:
        'Filter selections are automatically persisted. This cannot be disabled.',
      manualSave: 'Persist current filter selections',
      calendarFilter: {
        defaultTitle: 'Date',
        placeholder: 'Select date',
      },
      dateRangeFilter: {
        placeholderFrom: 'From',
        placeholderTo: 'To',
      },
      monthRangeFilter: {
        presets: {
          qtd: 'QTD',
          ytd: 'YTD',
          sinceInception: 'Since Inception',
        },
      },
      comparisonFilter: {
        baseEntity: 'Base entity',
        comparisonEntity: 'Comparison entity',
        multipleComparisonFiltersError:
          'Configuration error: Only one comparison filter is allowed per page.',
      },
    },
    pagination: {
      summary:
        '{{firstShownEntry, number}} - {{lastShownEntry, number}} of {{totalEntries, number}} Entries',
      summaryShort:
        '{{totalEntries, number}} of {{totalEntries, number}} Entries',
      selectItem: '{{entries, number}} per page',
      selectedRows: '{{selectedRowsCount, number}} selected',
      entryLimit: ' (Limited to {{totalEntries, number}} Entries)',
    },
    pageReference: {
      reference_one: 'p. {{pages}}',
      reference_other: 'pp. {{pages}}',
    },
    table: {
      tooltip: {
        maliciousContent:
          'Our checks conducted indicate that the file uploaded may contain some active or even malicious content. Therefore it was locked for all further actions.',
      },
      searchResultPagination:
        '{{shownResults, number}} of {{totalResults, number}} results',
      customizationModal: {
        title: 'Table settings',
        divider: 'Move fixed columns above this bar',
        groupedDivider: 'Move grouped columns above this bar',
        resetChanges: 'Reset to default settings',
        cancel: 'Cancel',
        apply: 'Save & Exit',
        selectAll: 'Select all',
        groupingHeader:
          'You can group this table by up to {{maxColumns, number}} columns at the same time.',
        groupingNote: 'Please note, only specific columns are groupable.',
      },
      filterModal: {
        title: 'Filter settings',
        resetChanges: 'Remove all filters',
        cancel: 'Cancel',
        apply: 'Save & Exit',
        selectAll: 'Select all',
      },
      showMoreEntry_one: '+ {{ count }} more entry',
      showMoreEntry_other: '+ {{ count }} more entries',
      workflowActionModal: {
        apply: 'Confirm',
        cancel: 'Cancel',
        successMessage: 'The action has been successfully executed.',
        fileUploadRequired: 'At least one file is required.',
        actionSuccessfulCountTimes_one:
          'The action was successful for {{ count }} item',
        actionSuccessfulCountTimes_other:
          'The action was successful for {{ count }} items',
        actionFailedCountTimes_one: 'but failed for {{ count }} item',
        actionFailedCountTimes_other: 'but failed for {{ count }} items',
      },
      documentSigning: {
        initializationErrorNotification:
          'An error occurred while initializing the document signing process',
        finalizingErrorNotification:
          'An error occurred while finalizing the document signing process',
        finalizingNotification: 'Finalizing document signing',
        successNotification: 'Document signing was successful',
      },
      deleteConfirmation: {
        cancel: 'Cancel',
        apply: 'Delete',
        title: 'Delete',
        message_one: 'Do you really want to delete this row?',
        message_other: 'Do you really want to delete {{count}} rows?',
      },
    },
    monthQuarterPicker: {
      modeMonthly: 'Monthly',
      modeQuarterly: 'Quarterly',
      placeholderMonth: 'Select a month',
      placeholderQuarter: 'Select a quarter',
      placeholderYear: 'Select a year',
    },
    periodPicker: {
      month: 'Month',
      quarter: 'Quarter',
    },
    periodRangePicker: {
      earlier: 'Earlier periods',
      from: 'From',
      later: 'Later periods',
      to: 'To',
    },
    datepicker: {
      qtd: 'Quarter to date',
      qtdShort: 'QTD',
      ytd: 'Year to date',
      ytdShort: 'YTD',
      ltm: 'Last twelve months',
      ltmShort: 'LTM',
      sinceInception: 'All dates until today',
      sinceInceptionShort: 'Since Inception',
    },
    select: {
      noOptionsAvailable: 'No options available',
      noOptionsFound: 'No options matching search term',
      createOption: 'Create "{{value}}"',
      creatableHint: 'New entries can be added by typing into the field.',
      selectAbove: 'Select all of the above',
    },
    search: {
      placeholder: 'Search',
    },
    noAccessError: {
      headline: 'Application access denied',
      message: 'You are not authorized to access this application.',
      resolution:
        'If you think this is an error, please request assistance from your support contact.',
      logoutButton: 'Logout',
    },
    fullScreenError: {
      loadingError: 'Failed to load application',
      genericError: 'An error occurred',
      actions: {
        retry: 'Try again',
        logout: 'Logout',
      },
      tenantNotFound: {
        headline: 'Tenant not found',
        message:
          'The requested tenant <strong>{{tenantName}}</strong> is not available. Did you use the correct URL?',
      },
      serviceUnavailable: {
        headline: 'Service Temporarily Unavailable',
        message:
          'This application is currently undergoing maintenance. Please try again later.',
      },
      networkError: {
        headline: 'Network Error',
        message:
          'A network error prevented the application from loading. Please check your network connection and try again.',
      },
      plannedMaintenance: {
        headline: 'Service undergoing maintenance',
        message:
          'This application is currently undergoing planned maintenance. Please try again later.',
      },
    },
    tenantNotFoundError: {
      headline: 'Tenant not found',
      message:
        'The requested tenant <strong>{{tenantName}}</strong> is not available. Did you use the correct URL?',
      action: 'Please refresh the page',
    },
    networkError: {
      message:
        'Unable to connect to the server. Please check your internet connection and try again.',
    },
    tenantConfigurationLoading: {
      headline: 'Loading configuration',
    },
    tenantPortalDataLoading: {
      headline: 'Loading portal data',
    },
    notifications: {
      goToPage: 'Go to page',
      copyContentId: {
        success: 'ID copied to clipboard.',
        error: "Couldn't copy ID. Please copy it manually: {{id}}",
      },
      export: {
        error:
          'Downloading exported data <strong>{{fileName}}</strong> failed.',
        loading: 'Downloading exported data <strong>{{fileName}}</strong>.',
        success:
          'Exported data <strong>{{fileName}}</strong> successfully downloaded.',
      },
      filterPersistence: {
        error: 'Persisting current filter selections failed.',
        loading: 'Persisting current filter selections.',
        success: 'Current filter selections were successfully persisted.',
      },
      bulkDownload: {
        error_one: 'Generating archive for {{count}} document failed.',
        error_other: 'Generating archive for {{count}} documents failed.',
        loading_one: 'Generating archive for {{count}} document.',
        loading_other: 'Generating archive for {{count}} documents.',
        success_one: 'Download of archive with {{count}} document started.',
        success_other: 'Download of archive with {{count}} documents started.',
      },
      downloadRow: {
        error: 'Failed to load table row data: {{- message}}',
        loading_one: 'Loading data for {{count}} row',
        loading_other: 'Loading data for {{count}} rows',
        success_one: 'Starting to download data for {{count}} row',
        success_other: 'Starting to download data for {{count}} rows',
      },
      rowRequest: {
        error: 'Failed to execute "{{label}}" request: {{- message}}',
        loading_one: 'Sending "{{label}}" request for {{count}} row',
        loading_other: 'Sending "{{label}}" request for {{count}} rows',
        success_one:
          'Successfully executed "{{label}}" request for {{count}} row',
        success_other:
          'Successfully executed "{{label}}" request for {{count}} rows',
      },
      markAsRead: {
        error_one: 'Failed to mark document as read.',
        error_other: 'Failed to mark {{count}} documents as read.',
        success_one: 'Document successfully marked as read.',
        success_other: '{{count}} documents successfully marked as read.',
      },
      markAsUnread: {
        error_one: 'Failed to mark document as unread.',
        error_other: 'Failed to mark {{count}} documents as unread.',
        success_one: 'Document successfully marked as unread.',
        success_other: '{{count}} documents successfully marked as unread.',
      },
      delete: {
        error_one: 'Failed to delete row.',
        error_other: 'Failed to delete {{count}} rows.',
        success_one: 'Row successfully deleted.',
        success_other: '{{count}} rows successfully deleted.',
      },
      documentDownload: {
        loading: 'Downloading document <strong>{{fileName}}</strong>.',
        success:
          'Document <strong>{{fileName}}</strong> successfully downloaded.',
        error: 'Failed to download document <strong>{{fileName}}</strong>.',
      },
      staticFileDownload: {
        loading: 'Downloading file.',
        success: 'File successfully downloaded.',
        error: 'Failed to download file.',
      },
      inlineEdit: {
        loading: 'Saving change.',
        success: 'Change saved.',
        error: 'Failed to save change.',
      },
      maintenance: {
        title: 'Maintenance Mode',
        plannedMaintenanceMessage:
          'This application is currently undergoing planned maintenance. Please try again later.',
        message:
          'This application is currently undergoing maintenance. Please try again later.',
        action: 'Reload Page',
      },
    },
    dataRefresh: {
      dataRefreshlabel: 'Latest data refresh',
      closedQuarterLabel: 'Latest closed quarter',
      tooltip:
        'Latest data refresh: {{formattedRefreshDate}}\nLatest closed quarter: {{formattedClosedQuarterDate}}',
      tooltipWithDataRefresh: 'Latest data refresh: {{formattedRefreshDate}}',
      tooltipWithClosedQuarted:
        'Latest closed quarter: {{formattedClosedQuarterDate}}',
    },
    disclaimer: {
      accept: 'I agree',
      cancel: 'Cancel',
      defaultTitle: 'Disclaimer',
    },
    detailPageCreationModal: {
      title: 'Comparison settings',
      cancel: 'Cancel',
      apply: 'Compare',
      layoutLabel: 'Layout',
      filteredRowsWarning:
        'Some selected rows were excluded because they have no data or duplicate identifiers for this layout.',
    },
    widget: {
      action: {
        label: {
          additionalInformation: 'Additional information',
          bulkActions: 'Bulk actions',
          closeFullscreen: 'Exit fullscreen view',
          downloadCsvUnfiltered: 'Download all data as CSV',
          downloadCsvFiltered: 'Download filtered data as CSV',
          downloadCsvSelectedRows: 'Download selected rows as CSV',
          customFilter: 'Datatable custom filters',
          customization: 'Datatable customization',
          delete: 'Delete',
          download: 'Download Documents',
          edit: 'Edit',
          downloadXlsxFiltered: 'Download filtered data as Excel XLSX',
          downloadXlsxSelectedRows: 'Download selected rows as Excel XLSX',
          downloadXlsxReadOnly: 'Download audit trail as Excel XLSX',
          downloadXlsxUnfiltered: 'Download all data as Excel XLSX',
          downloadGroupDataXlsx: 'Download group data as Excel XLSX',
          downloadGroupDataCsv: 'Download group data as CSV',
          imageDownload: 'Download chart as image',
          imageDownloadWithBackground:
            'Download chart as image with background',
          initFoundOperation: 'Create fund operation',
          markAsRead: 'Mark as read',
          markAsUnread: 'Mark as unread',
          openInFullscreen: 'Open in fullscreen',
          shareActions: 'Share actions',
          createRow: 'Create row',
          createInvestmentLimit: 'Create limit',
          dataIngestion: 'Create data ingestion workflow',
          downloadStaticFile: 'Download',
          copyContentId: 'Copy Content ID (API)',
          openDetailPage: 'Open {{label}} details',
          compareData: 'Compare data',
          aggregateData: 'Aggregate data',
          moveContentUp: 'Move content up',
          moveContentDown: 'Move content down',
          toggleContentWidth: 'Toggle content width',
          duplicateContent: 'Duplicate content',
          removeContent: 'Remove content',
        },
        tooltip: {
          compareData: 'Select at least two rows to compare data',
          aggregateData: 'Select at least two rows to aggregate data',
          downloadCsvUnfiltered:
            'Download data as CSV with no filters applied. Only visible table columns will be included in download. Customized table settings do apply.',
          downloadCsvFiltered:
            'Download data as CSV with current filters applied. Only visible table columns will be included in download. Customized table settings do apply.',
          downloadCsvSelectedRows:
            'Download only the currently selected rows as CSV. Current customized table settings still apply.',
          downloadXlsxFiltered:
            'Download data as Excel XLSX with current filters applied. Only visible table columns will be included in download. Customized table settings do apply.',
          downloadXlsxSelectedRows:
            'Download only the currently selected rows as Excel XLSX. Current customized table settings still apply.',
          downloadXlsxUnfiltered:
            'Download data as Excel XLSX with no filters applied. Only visible table columns will be included in download. Customized table settings do apply.',
          downloadXlsxReadOnly:
            'Download data as Excel XLSX as read-only with current filters applied. Only visible table columns will be included in download. Customized table settings do apply.',
          downloadGroupDataXlsx:
            'Download only the aggregated group rows as Excel XLSX. Individual data rows are excluded.',
          downloadGroupDataCsv:
            'Download only the aggregated group rows as CSV. Individual data rows are excluded.',
          copyContentId:
            'The data of this widget can be accessed via our API using the Content ID.',
        },
      },
    },
    upload: {
      zipUploadModal: {
        headline: 'Upload documents',
      },
      title_one: 'Drag and Drop your file here or ',
      title_other: 'Drag and Drop your files here or ',
      subtitle_one: 'Choose a file.',
      subtitle_other: 'Choose files.',
      permittedFormats: 'Permitted formats',
      maxFileSize: 'Max. file size',
      maxTotalSize: 'Max. total size',
      maxTotalSizeExceeded:
        'Total upload size must not exceed {{maxTotalSize}}.',
      maxFileCount: 'Max. file count',
      upload: 'Upload',
      uploadDocuments: 'Upload Documents',
      uploading: 'Uploading',
      fetchingMetadata: 'Loading',
      cancel: 'Cancel',
      close: 'Close',
      okay: 'OK',
      uploadFailed: 'Upload failed',
      rejected: 'Rejected Files',
      addedToUpload: 'Added Files',
      fileSummary_one: '{{ count }} File | {{ totalFileSize }}',
      fileSummary_other: '{{ count }} Files | {{ totalFileSize }}',
      info: {
        progress_one: 'File has been uploaded successfully.',
        progress_other:
          '{{ count }} of {{ total, number }} files have been uploaded successfully.',
        problemCount_one: 'There was a problem uploading 1 file.',
        problemCount_other: 'There was a problem uploading {{count}} files.',
      },
      uploadedFiles: 'Uploads',
      conditionalFilterOptionsError:
        'A system error occurred while loading meta data. Please cancel this operation and try again.',
      uploadZip: 'Upload zip-archive',
      back: 'Back',
      extractMetaData: {
        title: 'Meta data read from document',
        checkBtnLabel: 'Check file-specific metadata',
        fileName: 'File Name',
        size: 'Size',
        totalFiles_one:
          'Meta data was read successfully from {{success, number}} file.',
        totalFiles_other:
          'Meta data was read successfully from {{success, number}} of {{count}} files.',
        failedToExtract_one:
          'An error occurred when setting meta data for {{count}} file.',
        failedToExtract_other:
          'An error occurred when setting meta data for {{count}} files.',
      },
      noFiles: 'No files to upload',
      hideAndSelectAllFieldError:
        'Field {{title}} is configured as hide and select all which only supports a maximum 10 items.',
      metadataExtractinConfig: {
        label: 'Prepopulate metadata automatically',
        renameFilesLabel: 'Rename files according to naming convention',
        configOption: {
          fromAI: 'from file content',
          fromFileName: 'from file name',
          fromUser: 'do not prepopulate automatically',
        },
      },
      documentPreview: {
        title: 'Document preview',
        aiExtractionExplanation: 'AI extraction explanations',
      },
    },
    backToPage: 'Back to Page',
    forms: {
      placeholders: {
        text: 'Please enter a value',
        textarea: 'Please enter a text',
        number: 'Please enter a number (e.g. {{example}})',
        select: 'Please select a value',
        creatableSelect: 'Please select or enter a value',
        date: 'Please select a date',
        datetime: 'Please select a date and time',
      },
      validationErrors: {
        inputIsRequired: 'Input is required',
        minMaxNumberError: 'Expected {{expected}}',
        exclusiveMaximumError: 'Must be less than {{expected}}',
        exclusiveMinimumError: 'Must be greater than {{expected}}',
        maximumError: 'Must be at most {{expected}}',
        minimumError: 'Must be at least {{expected}}',
        patternError: 'Must match pattern {{pattern}}',
        minDateError: 'Date must not be before {{date}}',
        maxDateError: 'Date must not be after {{date}}',
        shouldBeMaxError:
          'Max of all partial sale should not be less than exit date',
      },
    },
    updateTableRow: {
      title_one: 'Edit entry ({{count}} item)',
      title_other: 'Edit entries ({{count}} items)',
      titleForTypeDoc_one: 'Edit document ({{count}} item)',
      titleForTypeDoc_other: 'Edit documents ({{count}} items)',
      updateError_one: 'Failed to update the entry',
      updateError_other: 'Failed to update {{count}} entries',
      cancel: 'Cancel',
      submit: 'Submit',
    },
    navigation: {
      dynamicNavSection: {
        title: 'Detail Pages',
        closeAll: 'Close all',
        errorNotification: 'Error closing detail page links',
      },
    },
    dashboard: {
      topNavigation: {
        addDashboard: 'Add dashboard',
        allDashboards: 'All dashboards ({{count}})',
      },
      allDashboardsModal: {
        title: 'All Dashboards',
        instanceSectionTitle: 'Dashboards in top navigation',
        availableSectionTitle: 'Other available dashboards',
        instanceSectionEmpty: 'No dashboards are shown in the top navigation.',
        availableSectionEmpty: 'No other dashboards are available.',
        sharingPrivate: 'Private',
        sharingGlobal: 'Global',
        moveUp: 'Move up',
        moveDown: 'Move down',
        hideTab: 'Hide tab',
        showTab: 'Show tab',
        delete: 'Delete',
        restore: 'Restore',
        cancel: 'Cancel',
        save: 'Save',
        saveSuccess: 'Dashboard navigation updated.',
        actionFailed:
          'Could not update dashboard navigation. Please try again.',
      },
      createModal: {
        title: 'Create Dashboard',
        nameLabel: 'Dashboard name',
        descriptionLabel: 'Description',
        cancel: 'Cancel',
        submit: 'Create Dashboard',
        submitFailed: 'Could not create the dashboard. Please try again.',
        createInstanceFailed:
          'The dashboard was created but could not be added to the top navigation. You can show it from All dashboards.',
      },
      deleteConfirmation: {
        title: 'Delete dashboard',
        message: 'Permanently delete "{{dashboardName}}"?',
        irreversibleWarning: 'Dashboard will be deleted after save is clicked.',
        permanentWarning: "This action can't be undone.",
        cancel: 'Cancel',
        confirm: 'Delete',
        deleteFailed: 'Could not delete the dashboard. Please try again.',
        deleteSuccess: 'Dashboard deleted.',
      },
      shareModal: {
        title: 'Share Dashboard',
        instruction: 'Choose who can view this dashboard.',
        privateLabel: 'Private',
        privateDescription: 'Keep visible only to you',
        globalLabel: 'Global',
        globalDescription: 'Make available to all organization members',
        submitFailed: 'Could not update sharing settings. Please try again.',
        submitSuccess: 'Sharing settings updated.',
      },
      emptyState: {
        noDashboards: {
          title: 'Create your first dashboard',
          description: 'Create a dashboard to start building your custom view.',
          action: 'Create dashboard',
        },
        noInstances: {
          title: 'Choose a dashboard',
          description:
            'Open All Dashboards to choose a dashboard for your top navigation.',
          action: 'All dashboards',
        },
        emptyDashboard: {
          title: 'This dashboard is empty',
          descriptionOwner: 'Add a component to start building your dashboard.',
          descriptionViewer:
            'This dashboard does not contain any components yet.',
          action: 'Add component',
        },
      },
      loading: 'Loading dashboard…',
      editAction: {
        label: {
          editLayout: 'Edit layout',
          cancel: 'Cancel',
        },
        saveFailed: 'Could not save the dashboard. Please try again.',
        saveOutcomeUnknown:
          'The save may have succeeded or failed. Reloading the dashboard — keep editing if your changes are still needed.',
      },
      placeholder: {
        pendingHydration: 'This component will load after you save.',
      },
      unsavedChanges:
        'You have unsaved dashboard changes. Leave without saving?',
      unsavedChangesModal: {
        title: 'Unsaved changes',
        message:
          'You have unsaved dashboard layout changes. Stay to keep editing, or discard them and leave.',
        stay: 'Stay',
        discard: 'Discard',
      },
    },
    initFundOperation: {
      title: 'Create fund operation',
      cancel: 'Cancel',
      submit: 'Submit',
      successMessage: 'The fund operation has been successfully created.',
      fundLoadingError:
        'A system error occurred while loading fund data. Please cancel this operation and try again.',
      currencyLoadingError:
        'A system error occurred while loading currency data. Please cancel this operation and try again.',
      error:
        'A system error occurred. Please cancel this operation and try again.',
    },
    createRow: {
      title: 'Create row',
      fileUploadRequired: 'At least one file is required.',
      cancel: 'Cancel',
      submit: 'Submit',
      okay: 'OK',
      submitting: 'Submitting',
    },
    investmentLimit: {
      title: 'Create Limit',
      viewTitle: 'Limit summary',
      close: 'Close',
      cancel: 'Cancel',
      back: 'Back',
      next: 'Next',
      create: 'Create Limit',
      creating: 'Creating',
      steps: {
        overview: 'General settings',
        parameter: 'Parameter',
        denominator: 'Denominator',
        workflow: 'Workflow & validity',
        review: 'Summary',
      },
      widgets: {
        overview: 'Overview',
        comparisonType: 'Comparison Type',
        limitParameters: 'Limit Parameters',
        evaluation: 'Evaluation',
        denominator: 'Denominator',
        workflow: 'Workflow',
        validity: 'Validity',
        review: 'Review',
      },
      mode: {
        aggregation: {
          label: 'Aggregation Limit',
          description:
            'Aggregate one or more records before comparing the result to a limit.',
        },
        position: {
          label: 'Position Limit',
          description:
            'Evaluate each record individually against a rule or threshold.',
        },
        exclusion: {
          label: 'Exclusion',
          description:
            'Forbid exposures by country, strategy, region, or industry.',
        },
        inclusion: {
          label: 'Inclusion',
          description:
            'Permits exposure only in the specified country, strategy, region, or industry.',
        },
      },
      valueType: {
        absolute: {
          label: 'Absolute',
          description: 'Compare the measured value directly to the limit.',
        },
        relative: {
          label: 'Relative',
          description:
            'Compare the measured value as a share of a denominator.',
        },
      },
      limitType: {
        regulatory: 'Regulatory',
        contractual: 'Contractual',
        client_specific: 'Client Specific',
        internal: 'Internal',
      },
      aggregationMethod: {
        sum: 'Sum',
        topN: 'Top N',
        bottomN: 'Bottom N',
      },
      dataField: {
        available_capital: 'Available Capital',
        cumulative_all_commitment: 'Cumulative All Commitment',
        cumulative_all_cost: 'Cumulative All Cost',
        cumulative_all_paid_in_inside_commitment:
          'Cumulative All Paid In Inside Commitment',
        cumulative_all_returned: 'Cumulative All Returned',
        days_to_final_termination_date: 'Days to Final Termination Date',
        days_to_investment_end_date: 'Days to Investment End Date',
        days_to_termination_date: 'Days to Termination Date',
        dpi: 'DPI',
        effective_valuation: 'Effective Valuation',
        exposure: 'Exposure',
        irr: 'IRR',
        nbr_count: 'Count',
        rvpi: 'RVPI',
        tvpi: 'TVPI',
        undrawn_commitment: 'Undrawn Commitment',
      },
      fields: {
        limitName: 'Limit name',
        limitNamePlaceholder: 'e.g. Max PE Fund Allocation',
        description: 'Description',
        descriptionPlaceholder: 'Describe the purpose of this limit',
        limitType: 'Limit Type',
        selectType: 'Select type',
        dataLevel: 'Data Level',
        selectLevel: 'Select level',
        currencyType: 'Currency Type',
        selectCurrencyType: 'Select currency type',
        removeFilter: 'Remove filter',
        selectNamed: 'Select {{label}}',
        kpi: 'KPI',
        selectKpi: 'Select a KPI',
        requiresDataLevel: 'Requires data level selection',
        limitOperator: 'Limit Operator',
        operatorPlaceholder: 'Op',
        limitValue: 'Limit Value',
        valuePlaceholder: 'Value',
        warningThreshold: 'Warning Threshold',
        warningPlaceholder: 'e.g. 80%',
        aggregationMethod: 'Aggregation Method',
        selectMethod: 'Select method',
        aggregationNumber: 'Aggregation Method Number',
        aggregationNumberPlaceholder: 'e.g. 10',
        evaluationMetric: 'Evaluation Metric',
        selectMetric: 'Select a metric',
        evaluationOperator: 'Evaluation Operator',
        evaluationValue: 'Evaluation Value',
        breachApproval: 'Limit breach approval',
        validFrom: 'Valid From',
        selectStartDate: 'Select start date',
        validTo: 'Valid To',
        selectEndDate: 'Select end date',
        validIndefinitely: 'Valid indefinitely (no end date)',
      },
      review: {
        none: 'None',
        yes: 'Yes',
        no: 'No',
        indefinitely: 'Indefinitely',
        limitName: 'Limit name',
        limitType: 'Limit type',
        limitMode: 'Limit mode',
        description: 'Description',
        comparisonType: 'Comparison type',
        dataLevel: 'Data level',
        currencyType: 'Currency type',
        filters: 'Filters',
        kpi: 'KPI',
        limitOperator: 'Limit Operator',
        limitValue: 'Limit Value',
        warningThreshold: 'Warning threshold',
        aggregationMethod: 'Aggregation Method',
        aggregationNumber: 'Aggregation Method Number',
        evaluationMetric: 'Evaluation Metric',
        evaluationOperator: 'Evaluation Operator',
        evaluationValue: 'Evaluation Value',
        breachApproval: 'Limit breach approval',
        validFrom: 'Valid from',
        validTo: 'Valid to',
      },
      preview: {
        dataSource: 'Data source',
        addFilter: 'Add filter',
        topLevelAggregation: 'Top Level aggregation',
        singlePositionExpression: 'Single position expression evaluation',
        kpiLimitComparison: 'KPI vs. Limit comparison',
        overview: 'Overview',
        parameter: 'Parameter',
        denominator: 'Denominator',
        workflow: 'Workflow and validity',
        limitMode: 'Limit mode',
        denominatorFieldsHint:
          'Evaluation fields are set on the denominator step.',
        inclusionBreachHint:
          'The limit is considered breached if any rows are found in the data source that do not match the specified filters.',
        exclusionBreachHint:
          'The limit is considered breached if any rows are found in the data source that match the specified filters.',
        denominatorIntro:
          'Select the data source used as the base for the relative calculation.',
        allRecords: 'Records for the selected currency type are shown below.',
        filteredRecords:
          'Affected records for the selected currency type, based on the added filters.',
        previewPlaceholder:
          'A preview of the affected entities appears here once a data level and a currency type are selected.',
        currencyTypePreviewPlaceholder:
          'Select a currency type to load the preview. The preview only includes records for that currency type.',
      },
      createFailed: 'The limit could not be created.',
    },
    dataIngestion: {
      title: 'New Data Import',
      cancel: 'Cancel',
      back: 'Back',
      next: 'Next',
      upload: 'Upload & parse file',
      uploading: 'Uploading',
      done: 'Done',
      configureAndDownload: {
        title: 'Configure & Download',
        configureImport: 'Set Import Metadata',
        noImportConfig:
          'The current data import does not require additional configuration',
        selectScope: 'Optional: Download prefilled Template',
        entitiesLabel: 'Entities to download pre-filled templates',
        prefillDataLabel: 'Download with current data entries',
        prefillDataHelpText:
          'If this option is set, the latest available data based on the Import Reference Date is prepopulated in the template.',
        downloadTemplate: 'Download Template',
        templateDownload: {
          loading: 'Downloading data ingestion template',
          success: 'Data ingestion template download started',
          error: 'Failed to download data ingestion template: {{- message}}',
        },
      },
      uploadAndParse: {
        title: 'Upload & Parse',
        templateInput: 'Template Input',
        executionLog: 'Import log',
        executionLogPlaceholder:
          'The result of the import will appear here once the upload is complete.',
        executionLogSuccess: 'Import completed successfully.',
        executionLogErrorFallback:
          'An unexpected error occurred. Please try again.',
      },
    },
    pageSidebar: {
      widgetTitle: 'Details',
      closeSidebar: 'Close sidebar',
      pinSidebar: 'Pin sidebar',
      unpinSidebar: 'Unpin sidebar',
      noDocumentsAvailable: 'No documents available',
      noPreviewAvailable: 'No preview available',
      previewUnavailableNotScanned:
        'This file was not scanned for threats. Preview is not available.',
      previewUnavailableMalicious:
        'This file may contain malicious content and was locked. Preview is not available.',
      download: 'Download',
      openInPage: 'Open in Documents',
      errorText: 'There was a problem loading related documents.',
    },
    aiAssistant: {
      addCurrentPage: 'Add page',
      addDocuments_one: 'Add document ({{count}})',
      addDocuments_other: 'Add documents ({{count}})',
      allChats: 'All chats',
      assistantTitle: 'AssetMetrix AI Assistant',
      cancel: 'Cancel',
      chatListSectionLast30Days: 'Last 30 days',
      chatListSectionLast7Days: 'Last 7 days',
      chatListSectionOlder: 'Older',
      chatListSectionToday: 'Today',
      chatListSectionYesterday: 'Yesterday',
      closeAssistant: 'Close assistant',
      closeSources: 'Close sources',
      collapseCitations: 'Hide citations',
      copied: 'Copied',
      copyReply: 'Copy reply to clipboard',
      composerPlaceholder: 'Ask the AssetMetrix AI Assistant…',
      deleteChat: 'Delete chat',
      deleteChatConfirm: 'Delete chat',
      deleteChatMessage:
        'Are you sure you want to delete this chat? This can’t be undone.',
      deleteChatMessageNamed:
        'Are you sure you want to delete “{{title}}”? This can’t be undone.',
      disclaimer:
        'You are interacting with an Artificial Intelligence (AI) system.',
      disclaimerParagraphs: [
        'You are interacting with an Artificial Intelligence (AI) system. Responses are generated by artificial intelligence based solely on content and data you are authorised to access within the AssetMetrix Platform. While designed to provide helpful and accurate information, responses may be incomplete or inaccurate and should not be relied upon as legal, financial, regulatory, or professional advice. The AI Assistant supports but does not replace human judgement or professional advice. Final responsibility for all decisions and actions remains with the user.',
        'Always verify important information before making decisions. The AI Assistant strictly respects user permissions and cannot access content beyond your authorised access rights.',
      ],
      disclaimerTitle: 'AI Assistant Disclaimer',
      downloadAllDocuments: 'Download all documents as a ZIP',
      downloadDocument: 'Download document',
      expandCitations: 'Show citations',
      hideChatList: 'Hide chat list',
      hideSources: 'Hide sources ({{count}})',
      jumpToSource: 'Jump to source {{index}}',
      loadingChats: 'Loading chats…',
      newChat: 'New chat',
      open: 'Open',
      openAssistant: 'Open AssetMetrix AI Assistant',
      openInPreview: 'Open in preview',
      overlapPageContent: 'Overlap page content',
      pinToPageLayout: 'Pin to page layout',
      removeDocumentContext: 'Remove {{label}}',
      removePageContext: 'Remove {{label}}',
      requestError: 'The AI assistant request failed. Please try again.',
      sendMessage: 'Send message',
      showChatList: 'Show chat list',
      showSources: 'Show sources ({{count}})',
      sourcesDocumentCount_one: '{{count}} document',
      sourcesDocumentCount_other: '{{count}} documents',
      sourcesLinkCount_one: '{{count}} link',
      sourcesLinkCount_other: '{{count}} links',
      sourcesTitle: 'Sources ({{count}})',
      sourcesTitleDocumentsAndLinks: 'Sources ({{documents}}, {{links}})',
      sourcesTitleLinks_one: 'Sources ({{count}} link)',
      sourcesTitleLinks_other: 'Sources ({{count}} links)',
      thinking: 'Thinking…',
    },
    pdfDocumentPreview: {
      close: 'Close preview',
      closeSearch: 'Close search',
      currentPage: 'Current page',
      disableHandTool: 'Disable hand tool',
      documentDetails: 'Document details',
      download: 'Download',
      fitPage: 'Fit page',
      fitWidth: 'Fit width',
      handTool: 'Hand tool (pan)',
      hideDocumentDetails: 'Hide document details',
      hidePages: 'Hide pages',
      horizontalLayout: 'Horizontal layout',
      loading: 'Loading document…',
      loadingError: 'Could not load this document.',
      moreTools: 'More tools',
      nextMatch: 'Next match',
      noResults: 'No results',
      previousMatch: 'Previous match',
      print: 'Print',
      rotate: 'Rotate',
      search: 'Search',
      searchPlaceholder: 'Find in document…',
      searchTitle: 'Search (Ctrl/Cmd+F)',
      showPages: 'Show pages',
      title: 'Document preview',
      verticalLayout: 'Vertical layout',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
    },
    vegaChartWidget: {
      groupingError: 'Column grouping is not configured for the datacolumns',
    },
    textFromTableWidget: {
      errorLoadingData: 'Unable to load dynamic data',
      missingColumnConfig:
        'Missing column configuration for placeholders: {{keys}}',
      noDataFound: 'No data found',
    },
    stakeAdjustment: {
      label: 'Stake adjusted',
      tooltip: 'Adjust all investment data to the direct stake of the investor',
    },
  },
} as const;

export default en;
